<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_case_escalation_process')"
  >
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">{{ $t("escalationprocess.title") }}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="row section-container">
            <div class="row">
              <div class="section-header">
                <strong>{{ $t("escalationprocess.addnew") }}</strong>
                <button
                  type="button"
                  v-if="
                    GET_ACCOUNT_DATA.id == 1 ||
                      has_perm('create_case_escalation_process')
                  "
                  class="btn btn-default btn-sm"
                  @click="onOpenAddEscaltionProcessInput"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="row" v-show="inputmode">
              <escalationprocess-input
                :item="selectedProcessInput"
                @save="onSaveProcessInput"
                @close="onHideProcessInput"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5 col-md-5 col-lg-5">
            <div class="row section-container">
              <div class="row">
                <div class="section-header">
                  <strong>{{ $t("escalationprocess.list") }}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 table-responsive">
                  <ul class="todo-list ui-sortable">
                    <li
                      v-for="escalation_process in escalation_process_items"
                      :key="escalation_process.id"
                    >
                      <span class="text"
                        >#{{ escalation_process.id }}
                        {{ escalation_process.name }}</span
                      >
                      <small class="label label-info"
                        >{{ escalation_process.stages.length }}
                        {{ $t("escalationstage.name") }}</small
                      >
                      <div class="tools">
                        <i
                          class="fa fa-eye"
                          v-if="
                            GET_ACCOUNT_DATA.id == 1 ||
                              has_perm('view_case_escalation_process')
                          "
                          @click="onViewEscalationProcess(escalation_process)"
                        ></i>
                        <i
                          class="fa fa-edit"
                          v-if="
                            GET_ACCOUNT_DATA.id == 1 ||
                              has_perm('update_case_escalation_process')
                          "
                          @click="onOpenEditProcess(escalation_process)"
                        ></i>
                        <i
                          class="fa fa-trash-o"
                          v-if="
                            GET_ACCOUNT_DATA.id == 1 ||
                              has_perm('delete_case_escalation_process')
                          "
                          @click="onDeleteEscalationProcess(escalation_process)"
                        ></i>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-7 col-md-7 col-lg-7">
            <div class="row section-container">
              <div class="row">
                <div class="section-header">
                  <strong
                    >{{ $t("escalationprocess.detail") }}
                    {{ selectedEscalationProcess.name }}</strong
                  >
                </div>
              </div>
              <div class="row">
                <div v-if="selectedEscalationProcess.id === null">
                  <i>{{ $t("escalationprocess.detailcontent") }}</i>
                </div>
                <div class="col-xs-12 table-responsive" v-else>
                  <table class="table table-hover">
                    <thead>
                      <th>{{ $t("escalationstage.name") }}</th>
                      <th>{{ $t("escalationstage.stage_due_date_no") }}</th>
                      <th>{{ $t("escalationstage.stage_poc") }}</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="stage in selectedEscalationProcess.stages"
                        :key="stage.id"
                      >
                        <td class="col-sm-3 col-md-3 col-lg-3">
                          <div>{{ stage.stage_details.name }}</div>
                        </td>
                        <td class="col-sm-3 col-md-3 col-lg-3">
                          <div>{{ stage.stage_details.stage_due_date_no }}</div>
                        </td>
                        <td class="col-sm-3 col-md-3 col-lg-3">
                          <div>
                            {{ stage.stage_details.poc_details.last_name }}
                            {{ stage.stage_details.poc_details.first_name }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Delet Confirm Modal Component -->
    <div class="modal fade" id="modal-escalationprocess-delete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("escalationprocess.deletetitle") }}
            </h4>
          </div>
          <div class="modal-body">{{ $t("escalationprocess.deletemsg") }}</div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onConfirmDelete"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import utils from '@/lib/utils';
import { mapGetters, mapActions } from "vuex";
import EscalationProcessInput from "./EscalationProcessInput.vue";

export default {
  name: "EscalationProcess",
  data() {
    return {
      inputmode: false,
      escalation_stage_items: [],
      selectedEscalationProcess: {
        id: null,
        name: null,
        stages: []
      },
      selectedProcessInput: {
        id: 0,
        name: "",
        stages: []
      },
      escalation_process_id: 0
    };
  },
  computed: {
    ...mapGetters([
      "ESCALATION_PROCESS_LIST",
      "GET_ACCOUNT_DATA"
    ]),
    escalation_process_items: function() {
      let items = [];
      this.ESCALATION_PROCESS_LIST.forEach(v => {
        let id = v.id;
        let name = v.name;
        let stages = v.stages;
        let item = {
          id: id,
          name: name,
          stages: stages
        };
        items.push(item);
      });
      return items;
    }
  },
  methods: {
    ...mapActions([
      "GET_ESCALATION_PROCESS_LIST",
      "GET_ESCALATION_STAGE_LIST",
      "ADD_ESCALATION_PROCESS",
      "UPDATE_ESCALATION_PROCESS",
      "DELETE_ESCALATION_PROCESS"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onOpenAddEscaltionProcessInput() {
      this.inputmode = true;
      this.selectedProcessInput = {
        id: 0,
        name: "",
        stages: []
      };
      this.escalation_process_id = this.selectedProcessInput.id;
    },
    onHideProcessInput() {
      this.inputmode = false;
    },
    onOpenEditProcess(es_process) {
      this.onOpenAddEscaltionProcessInput();
      this.selectedProcessInput = es_process;
      this.escalation_process_id = this.selectedProcessInput.id;
    },
    onSaveProcessInput(process) {
      let payload = {
        id: this.escalation_process_id,
        data: process
      };

      if (payload.id == 0) {
        this.ADD_ESCALATION_PROCESS(payload).then(
          function() {
            this.GET_ESCALATION_PROCESS_LIST().then(
              function() {
                this.onHideProcessInput();
                this.reloadProcessDetails();
              }.bind(this)
            );
          }.bind(this)
        );
      } else {
        this.UPDATE_ESCALATION_PROCESS(payload).then(
          function() {
            this.GET_ESCALATION_PROCESS_LIST().then(
              function() {
                this.onHideProcessInput();
                this.reloadProcessDetails();
              }.bind(this)
            );
          }.bind(this)
        );
      }
    },
    onDeleteEscalationProcess(escalation_process) {
      $("#modal-escalationprocess-delete").modal("show");
      this.onDeletedProcess = escalation_process;
    },
    onConfirmDelete: function() {
      $("#modal-escalationprocess-delete").modal("hide");
      let data = {
        id: this.onDeletedProcess.id
      };
      this.DELETE_ESCALATION_PROCESS(data)
        .then(
          function() {
            this.GET_ESCALATION_PROCESS_LIST();
            this.reloadProcessDetails();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onViewEscalationProcess(escalation_process) {
      this.selectedEscalationProcess = escalation_process;
    },
    reloadProcessDetails() {
      this.selectedEscalationProcess = {
        id: null,
        name: null,
        stages: []
      };
    }
  },
  components: {
    "escalationprocess-input": EscalationProcessInput
  },
  mounted() {
    this.GET_ESCALATION_PROCESS_LIST().then(
      function() {
        this.GET_ESCALATION_STAGE_LIST();
      }.bind(this)
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section-container {
  margin-bottom: 25px;
}

.section-header {
  margin: 10px 0 20px 0;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.resize-width {
  width: 100%;
}

.height-26 {
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/EscalationProcess.vue